import React from 'react';

import { TailAdminStatusBadge } from '@/components/template/tailadmin/DashboardPrimitives';


const CampaignTypeBadge = ({ requestType, directVersion }) => {
  if (requestType === 'direct') {
    return (
      <TailAdminStatusBadge tone="primary">
        Direct {directVersion ? directVersion.toUpperCase() : ''}
      </TailAdminStatusBadge>
    );
  }
  if (requestType === 'broadcast') {
    return <TailAdminStatusBadge tone="success">Broadcast</TailAdminStatusBadge>;
  }
  return <TailAdminStatusBadge tone="neutral">Legacy</TailAdminStatusBadge>;
};

export default CampaignTypeBadge;
